import { jsx as _jsx } from "react/jsx-runtime";
export const NextArrowIcon = ({ disabled })=>/*#__PURE__*/ _jsx("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.03249 6.42308L2.31657 0.819336C2.18437 0.689624 2.00789 0.618164 1.81972 0.618164C1.63155 0.618164 1.45507 0.689624 1.32287 0.819336L0.901927 1.23192C0.62802 1.50076 0.62802 1.93771 0.901927 2.20614L5.70173 6.91183L0.896602 11.6227C0.764399 11.7524 0.691406 11.9254 0.691406 12.1097C0.691406 12.2943 0.764399 12.4672 0.896602 12.5971L1.31754 13.0095C1.44985 13.1393 1.62622 13.2107 1.81439 13.2107C2.00257 13.2107 2.17905 13.1393 2.31125 13.0095L8.03249 7.40068C8.16501 7.27056 8.23779 7.09682 8.23738 6.91213C8.23779 6.72673 8.16501 6.5531 8.03249 6.42308Z",
            fill: disabled ? "#C5C7D0" : "#6161FF"
        })
    });
